import { Button } from '@/components/ui/Button';
import { Text } from '@/components/ui/Text';

export const HelpBlock = () => (
  <div className='HelpBlock flex max-w-[1388px] flex-col gap-[40px] py-[70px] text-center lg:py-[120px]'>
    <Text variant='h1-serif' color='dark' className='text-center'>
      Have questions? Schedule a call with our Membership Team.
    </Text>

    <div>
      <Button href='/contact-us' target='_blank' variant='cream'>
        Schedule A Call
      </Button>
    </div>
  </div>
);
